var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$config.runtime.theme.header.options.fitmentIcon === 'JEEP')?_c('JeepIcon'):(_vm.$config.runtime.theme.header.options.fitmentIcon === 'BRONCO')?_c('BroncoIcon'):_c('TruckIcon')
}
var staticRenderFns = []

export { render, staticRenderFns }